import api from '../../api/apiService';
import { Profile } from '../../models/Profile';
import { getCurrentUser } from '../auth';

const profileUri = (userId: string) => `/profile/v1/profiles/${userId}`;

let profilePromise: Promise<Profile>;

export const saveProfile = (profile: Partial<Profile>): Promise<Profile> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    throw new Error('Failed to get userId for profile');
  }
  profilePromise = api.patch<Profile>(`profile/v1/profiles/${userId}`, profile).then((response) => response.data);
  return profilePromise;
};

export const fetchProfile = (): Promise<Profile> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    throw new Error('Failed to get userId for profile');
  }
  profilePromise = api.get<Profile>(profileUri(userId)).then((response) => response.data);
  return profilePromise;
};

export const getProfile = (): Promise<Profile> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject('Failed to get userId for profile');
  }
  return profilePromise ?? fetchProfile();
};
